module.exports = __webpack_public_path__ + "img/skellet.2a170453.jpg";